import ErrorPageTemplate from "../../components/ErrorPageTemplate";

export default function InternalServerError() {
    return (
        <ErrorPageTemplate 
            errorImage="img/error_500.png"
            errorDescription={"Desculpe, você não tem acesso a página que tentou acessar,\npara mais dúvidas contatar o suporte."}
            buttonText="Voltar para página anterior"
            buttonLink="/"
        />
    )
}